<template>
    <el-dialog width="60%" title="提示 ：" :visible.sync="viewDetail" @close="closeModel">
        <el-row type="flex" align="middle" justify="center" class="style-row"> 当前用户定位数不足请充值 </el-row>
        <el-row type="flex" align="middle" justify="center" class="style-row"> 注：发起定位二维码活动需要购买充值位置数 </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeModel">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="loading">去充值购买</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            viewDetail: true,
            loading: false,
        };
    },
    methods: {
        closeModel() {
            this.$emit("closeModel");
        },
        handleSubmit() {
            this.$router.push("/home/toollist");
        },
    },
    mounted() {},
    components: {},
};
</script>

<style scoped lang="scss">
.style-row {
    font-size: 20px;
    height: 40px;
}
</style>
